import { useCustomLocationName } from 'views/mutual/location/hooks';
import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { useNavigate } from 'react-router-dom';
import { PagePath } from 'constants/pagePath';

export const ApplicationDenied = () => {
  const navigate = useNavigate();
  useCustomLocationName('米国納税義務（FATCA）に関する確認')
  return (
    <div className="error">
      <div className="error_description-wrapper">
          <span className="error_description-wrapper_description">
            {'ＦＡＴＣＡご申告内容に、対面でのお手続きが必要な項目がございます。'}
          </span>
          
          <span className="error_description-wrapper_description">
            <span>
              {"恐れ入りますが最寄りの営業店もしくは"}
              <a className = "checkLabel_labels_link" onClick={() => navigate(PagePath.Contact)}>お問い合わせ</a>
              {"からご連絡をお願いします。"}
            </span>
          </span>
      </div>
      <div className='error_button-wrapper'>
      <Button
        type={ButtonType.Submit}
        label="HOMEに戻る"
        buttonFill={ButtonFill.link}
        buttonSize={ButtonSize.small}
        onClick={() => navigate(PagePath.Home)}
      />
      </div>      
    </div>      
  );
}